// THIS FILE DOES NOT FOLLOW ANGULAR INJECTORS
// THIS IS MEANT TO BE API-COMPATIBLE WITH CROSS-STORAGE
// TODO: do this better!

export class CrossStorageClient {
  constructor(private hubUrl: string, _: any) {}

  get(key: string): Promise<any>;
  get(...keys: string[]): Promise<any[]>;
  get(...keys: string[]): Promise<any[]> {
    return this.send("get", {
      key: keys.length > 1 ? keys : keys[0]
    });
  }

  getKeys(): Promise<string[]> {
    return this.send("getKeys");
  }

  set(key: string, value: any, ttl?: number): Promise<void> {
    return this.send("set", { key, value });
  }

  del(...keys: string[]): Promise<void> {
    return this.send("del", {
      key: keys
    });
  }

  clear(): Promise<void> {
    return this.send("clear");
  }

  private iframe?: HTMLIFrameElement;
  private init(): void {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    iframe.style.position = "absolute";
    iframe.style.zIndex = "-1";
    iframe.style.left = "0px";
    iframe.style.top = "0px";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";

    iframe.setAttribute("src", this.hubUrl);
    document.body.appendChild(iframe);

    window.addEventListener(
      "message",
      (event) => {
        let envelope;
        try {
          envelope = JSON.parse(event.data);
        } catch {
          return;
        }

        const resolve =
          Number(envelope.id) <= this.requestIdSeq &&
          this.requestResolvers.hasOwnProperty(envelope.id)
            ? this.requestResolvers[envelope.id]
            : null;

        if (resolve != null && typeof resolve === "function") {
          resolve(envelope.response);
        }
      },
      false
    );

    this.iframe = iframe;
  }

  private onConnectCache?: Promise<void>;
  onConnect(): Promise<void> {
    if (this.onConnectCache == null) {
      this.onConnectCache = new Promise((resolve, reject) => {
        this.init();

        const check = () => {
          if (Date.now() - start > 5000) {
            clearInterval(interval);
            reject(new Error("Could not connect to cross storage hub"));
          }

          this.sendRaw("init").then(() => {
            clearInterval(interval);
            resolve();
          });
        };

        const start = Date.now(),
          interval = setInterval(check, 100);
        check();
      });
    }
    return this.onConnectCache;
  }

  private async send<Request, Response>(
    type: string,
    request?: Request
  ): Promise<Response> {
    await this.onConnect();
    return this.sendRaw<Request, Response>(type, request);
  }

  private requestIdSeq: number = 0;
  private requestResolvers: Record<string, (value: any) => void> = {};
  private async sendRaw<Request, Response>(
    type: string,
    request?: Request
  ): Promise<Response> {
    const id = ++this.requestIdSeq,
      message = JSON.stringify({ type, id, request });

    return new Promise<Response>((resolve) => {
      this.requestResolvers[id] = resolve;
      this.iframe!.contentWindow!.postMessage(message, "*");
    });
  }
}
